import { render, staticRenderFns } from "./enrollmentdetail.vue?vue&type=template&id=011cccfb&"
import script from "./enrollmentdetail.vue?vue&type=script&lang=js&"
export * from "./enrollmentdetail.vue?vue&type=script&lang=js&"
import style0 from "./enrollmentdetail.vue?vue&type=style&index=0&id=011cccfb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports